import { mdiPencilOutline } from "@mdi/js"
import { buildTableRowActionSet } from "@kontextwerk/web-sdk/core/layout/table"
import type { InboxWorkflowRowActionProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
export const contactEditorActions = (props: InboxWorkflowRowActionProps, reason: string | null) =>
  buildTableRowActionSet(
    [
      {
        id: "edit-contact",
        label: "Angaben bearbeiten",
        tooltip: "Angaben bearbeiten",
        icon: mdiPencilOutline,
        disabled: props.disabled || Boolean(reason) || !props.openEditor,
        disabledReason:
          reason ||
          (props.disabled ? "Diese Zeile ist abgeschlossen oder wird gerade verarbeitet." : null),
        onClick: () => props.openEditor?.(),
      },
    ],
    { primaryId: "edit-contact" },
  )
